
import { supabase } from '@/integrations/supabase/client';
import { SubscriptionCreate } from '@/services/types/subscriptionTypes';
import { calculateNextPaymentDate, formatDateForApi } from '@/utils/dateUtils';

export async function createSubscription(subscription: SubscriptionCreate) {
  try {
    // Рассчитываем дату следующего платежа, если она не указана
    if (!subscription.next_payment_date) {
      const nextPaymentDate = calculateNextPaymentDate(
        subscription.start_date || new Date().toISOString(),
        subscription.interval
      );
      subscription.next_payment_date = formatDateForApi(nextPaymentDate);
    }
    
    // Преобразуем start_date к строке, если это объект Date
    if (subscription.start_date && typeof subscription.start_date === 'object') {
      subscription.start_date = formatDateForApi(subscription.start_date as any);
    }
    
    console.log('Создание подписки с данными:', subscription);
    
    const { data, error } = await supabase
      .from('subscriptions')
      .insert(subscription)
      .select();

    if (error) {
      console.error('Ошибка при создании подписки:', error);
      return { data: null, error: error.message, success: false };
    }

    return { data: data[0], error: null, success: true };
  } catch (err: any) {
    console.error('Непредвиденная ошибка при создании подписки:', err);
    return { data: null, error: err.message, success: false };
  }
}
